import { render, staticRenderFns } from "./CreditOffered.vue?vue&type=template&id=977b2fb8&scoped=true&"
import script from "./CreditOffered.vue?vue&type=script&lang=js&"
export * from "./CreditOffered.vue?vue&type=script&lang=js&"
import style0 from "./CreditOffered.vue?vue&type=style&index=0&id=977b2fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977b2fb8",
  null
  
)

export default component.exports